import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Header } from './-header/-components';
import { DevDocumentDetailOutletWithForm } from './_layout/-context/dev-document-tab-form-context';
import { DevDocumentFormStore } from './_layout/-store/store';

/**
 * 開発ドキュメント 詳細画面の Layout。
 *
 * 開発チケット詳細の `_layout.tsx` と同じパターン。CForm / Zustand store /
 * DevDocumentDetailOutletWithForm による section 単位編集を提供する。
 */
export const Route = createFileRoute('/_stacktrace/development-documents/$id/_layout')({
  component: Layout
});
function Layout() {
  const store = DevDocumentFormStore.createStore();
  return <DevDocumentFormStore.Provider value={store}>
      <VStack>
        <Header />
        <DevDocumentDetailOutletWithForm />
      </VStack>
    </DevDocumentFormStore.Provider>;
}